import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-30efdace"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "banner" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 1,
  class: "text"
}
const _hoisted_4 = { class: "banan" }
const _hoisted_5 = { class: "mainbox" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "新闻动态", -1))
const _hoisted_7 = { class: "tops" }
const _hoisted_8 = { class: "carouse" }
const _hoisted_9 = { style: {"display":"flex","height":"2rem","justify-content":"space-between"} }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "img" }
const _hoisted_12 = ["src"]
const _hoisted_13 = {
  key: 0,
  style: {"position":"relative"},
  class: "tex"
}
const _hoisted_14 = { class: "ellip" }
const _hoisted_15 = { class: "ellip" }
const _hoisted_16 = { style: {"position":"absolute","bottom":"0.5rem"} }
const _hoisted_17 = { class: "list" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-tupian iconfont" }, null, -1))
const _hoisted_20 = { class: "info" }
const _hoisted_21 = { class: "ellip" }
const _hoisted_22 = {
  key: 0,
  style: {"position":"absolute","bottom":"0.2rem","color":"#666666"}
}
const _hoisted_23 = {
  key: 0,
  class: "menu"
}
const _hoisted_24 = ["onClick"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-gjiantous" }, null, -1))
const _hoisted_26 = { class: "pagination" }

import { reactive, onMounted, watch, ref } from "vue";
import Nav from "@/components/nav/Index.vue";

import { useRouter, useRoute } from "vue-router";
import { getNwes } from "@/api/backstage";

const __default__ = {
  name: "news",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  isMobile: Boolean,
},
  setup(__props) {

const props = __props



const mb = ref(false);
watch(
  () => props.isMobile,
  (newv, oldv) => {
    props.isMobile ? (mb.value = true) : (mb.value = false);
  }
);
const acrRef: any = ref(null);
const router = useRouter();
const route = useRoute();
const menu = ref([
  { title: "全部", key: 0, checked: true },
  { title: "一周内", key: 1, checked: false },
  { title: "一月内", key: 2, checked: false },
  { title: "一季度内", key: 3, checked: false },
  { title: "一年内", key: 4, checked: false },
]);
const datas: any = reactive({
  banner: "",
  filurl: localStorage.getItem("fileUrel"),
  total: 0,
  items: [],
  tops: [],
  form: {
    newsType: "NEWS_NEWS",
    pageNum: 1,
    dateType: "",
    pageSize: 15,
    isTop: 0,
    status: "STATUS_YES",
  },
  topform: {
    isTop: 1,
    status: "STATUS_YES",
    newsType: "NEWS_NEWS",
  },
});

const getData = () => {
  getNwes(datas.form).then((res: any) => {
    for (const item of res.data.list) {
      if (item.fileName) item.fileurl = localStorage.getItem("fileUrel") + item.fileName;
    }
    datas.items = res.data.list;
    datas.total = res.data.total;
  });
};

const getTop = () => {
  getNwes(datas.topform).then((res: any) => {
    for (const item of res.data.list) {
      if (item.fileName) item.fileurl = localStorage.getItem("fileUrel") + item.fileName;
    }
    console.log(res.data);
    
    datas.tops = res.data.list.slice(0, 2);
    console.log(222222222222);
    console.log(datas.tops);
    
    setTimeout(() => {
      acrRef.value?.setActiveItem(0);
    }, 100);
  });
};

const open = (url: any) => {
  // window.open(url, '_blank');
  router.push(url);
};
const handleCurrentChange = (val: number) => {
  datas.form.pageNum = val;
  getData();
};

const check = (i: any) => {
  datas.form.dateType = menu.value[i].key;
  for (const list of menu.value) {
    list.checked = false;
  }
  menu.value[i].checked = true;
  getData();
};

const getBanner = (banner: any) => {
  datas.banner = banner;
};

onMounted(() => {
  getData();
  getTop();
  mb.value = props.isMobile;
});

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(mb.value ? 'Mobile' : 'pc')
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(Nav, {
        isMobile: mb.value,
        onGetBanner: getBanner
      }, null, 8, ["isMobile"]),
      (datas.banner.length == 1)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: datas.filurl + datas.banner[0].fileName,
            alt: ""
          }, null, 8, _hoisted_2))
        : _createCommentVNode("", true),
      (datas.banner.length == 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("h1", _hoisted_4, _toDisplayString(datas.banner[0].title), 1),
            _createElementVNode("p", null, _toDisplayString(datas.banner[0].description), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datas.tops, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                style: {},
                key: index
              }, [
                _createElementVNode("div", {
                  class: "item",
                  onClick: ($event: any) => (open(`/website/news/details?id=${item.id}`))
                }, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("img", {
                      src: item.fileurl,
                      alt: ""
                    }, null, 8, _hoisted_12)
                  ]),
                  (!mb.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createElementVNode("h4", _hoisted_14, _toDisplayString(item.title), 1),
                        _createElementVNode("p", _hoisted_15, _toDisplayString(item.summary), 1),
                        _createElementVNode("p", _hoisted_16, _toDisplayString(item.pushTime), 1)
                      ]))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_10)
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datas.items, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            style: {"position":"relative"},
            class: "item",
            key: index,
            onClick: ($event: any) => (open(`/website/news/details?id=${item.id}`))
          }, [
            _createVNode(_component_el_image, {
              src: item.fileurl,
              fit: "fill"
            }, {
              error: _withCtx(() => [
                _hoisted_19
              ]),
              _: 2
            }, 1032, ["src"]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("h4", _hoisted_21, _toDisplayString(item.title), 1),
              (!mb.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_22, _toDisplayString(item.pushTime), 1))
                : _createCommentVNode("", true)
            ])
          ], 8, _hoisted_18))
        }), 128)),
        (!mb.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menu.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: index,
                    onClick: ($event: any) => (check(index)),
                    class: _normalizeClass({ checked: item.checked })
                  }, [
                    _hoisted_25,
                    _createTextVNode(" " + _toDisplayString(item.title), 1)
                  ], 10, _hoisted_24))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createVNode(_component_el_pagination, {
          background: "",
          layout: "prev, pager, next",
          "page-size": datas.form.pageSize,
          onCurrentChange: handleCurrentChange,
          total: datas.total
        }, null, 8, ["page-size", "total"])
      ])
    ])
  ], 2))
}
}

})